export var MessageRole;

(function (MessageRole) {
  MessageRole["User"] = "user";
  MessageRole["AIAssistant"] = "ai-assistant";
  MessageRole["System"] = "system";
})(MessageRole || (MessageRole = {}));